const NotFound404: React.FC = () => {
    return (
    <p>This page is under construction</p>
    );
}
export default NotFound404;